import React from 'react';
import Head from 'next/head';
// import TopHeader from '../components/TopHeader';
import Header from '../components/Header';
import CSRSection from '../components/CSRSection';
import Footer from '../components/Footer';

const CSRPage = () => {
    return (
        <>
            <Head>
                <title>Corporate Social Responsibility - PISCESIA</title>
                <meta name="description" content="Corporate Social Responsibility (CSR) is a vital component of our culture and a way of contributing to the society. Learn about our partnership with Manav Kalyan Foundation and our initiatives for community welfare." />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <link rel="icon" href="/favicon.ico" />
            </Head>
            
            {/* <TopHeader /> */}
            <Header />
            <main>
                <CSRSection showHealthText={true} />
            </main>
            <Footer showHealthText={true} />
        </>
    );
};

export default CSRPage;
